var map = {
	"./arconnect.svg": "59bf",
	"./arrow-angle-down-purple.svg": "507f",
	"./arrow-angle-down.svg": "5e92",
	"./arrow-angle-right-tx-more.svg": "c35a",
	"./arrow-angle-right.svg": "9a86",
	"./arrow-back.svg": "8077",
	"./arrow-bridge-purple.svg": "e708",
	"./arrow-down.svg": "979a",
	"./arweave.svg": "154d",
	"./bridge-purple.svg": "0157",
	"./bridge.svg": "f0bc",
	"./check.svg": "5621",
	"./close.svg": "cf5a",
	"./collection-from-purple.svg": "d754",
	"./collection-from.svg": "ebc8",
	"./d1.svg": "bb77",
	"./developers-purple.svg": "4a62",
	"./developers.svg": "254b",
	"./discord-2.svg": "8b0c",
	"./discord-3.svg": "e25d",
	"./discord-purple.svg": "cf14",
	"./discord.svg": "2e1c",
	"./discover-dapps-purple.svg": "4226",
	"./discover-dapps.svg": "3f05",
	"./dodo.svg": "ad80",
	"./drf.svg": "edbb",
	"./everpay-small.svg": "cd5d",
	"./explore-purple.svg": "8704",
	"./explore.svg": "4c69",
	"./fantasmas.svg": "e696",
	"./github-2.svg": "ee62",
	"./github.svg": "0e65",
	"./hashkey.svg": "c9c2",
	"./lang-arrow-down-white.svg": "bcc1",
	"./lang-arrow-down.svg": "4098",
	"./languages.svg": "52a5",
	"./mask.svg": "ae92",
	"./medium-2.svg": "fc10",
	"./medium.svg": "883c",
	"./menu.svg": "054c",
	"./okex.svg": "5168",
	"./permaDAO.svg": "0cd8",
	"./permaswap.svg": "53a6",
	"./permaweb.svg": "07fb",
	"./sdk-arrow-right.svg": "eeae",
	"./sevenx.svg": "bb84",
	"./telegram-2.svg": "3afa",
	"./telegram.svg": "4707",
	"./twitter-2.svg": "ffa1",
	"./twitter.svg": "9195",
	"./w3I.svg": "3f04",
	"./wallet-black.svg": "b4fe",
	"./wallet-purple.svg": "7e9c",
	"./white-paper-purple.svg": "fa04",
	"./white-paper.svg": "4aa7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3a05";